import React from "react";
import { NavLink } from "react-router-dom";
import Department from "../../components/timesheet/Department";
import Year from "../../components/timesheet/Year";
import { useSidebarData } from "../../hooks/sidebarData";
import { useQuery } from "@tanstack/react-query";

const Parent = () => {
    const { setSidebarData } = useSidebarData();

    const uname = sessionStorage.getItem('uname') || ''; 

    const handleClearSidebarData = () => {
        setSidebarData('state', false);
        setSidebarData('key', '');
        setSidebarData('label', '');
        setSidebarData('data', []);
    };

    const { data: role } = useQuery({
        queryKey: ['userrole']
    });

    const { data: manageddepartments } = useQuery({
        queryKey: ['managedDepartments', uname]
    });

    const { data: managedadjustments } = useQuery({
        queryKey: ['managedAdjustments', uname]
    });

    return (
        <div className="parent">
            <div className="page-header">
                <div className='title'>
                    <h1>Timesheets</h1>
                    <ul className='breadcrumbs'>
                        <li>
                            <NavLink to='/dtr/my-dtr' onClick={handleClearSidebarData}>DTR</NavLink>
                        </li>
                        <li>
                            <span>Timesheets</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="content">
                <div className="files">
                    {(role === 'admin' || role === 'management') || manageddepartments?.length > 1 || managedadjustments?.length > 1  
                        ? <Department /> 
                        : <Year />
                    }
                </div>
            </div>
        </div>
    );
}

export default Parent;
